import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class TimeoutResolve implements Resolve<any> {
    resolve(): Promise<any> {
        return new Promise<void>((resolve) => {
            setTimeout(() => resolve(), 1000);
        });
    }
}
